import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import Arrow from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { Nav } from '@catalogo/core-nav';
import { getImageBanner } from '@catalogo/service-americanas-header/src/helpers/header';
import { timerEventMetric } from '@catalogo/service-americanas-header/src/helpers/metrics';
import Submenu from './submenu';
import AllDepartments from './all-departments';
import Categories from './submenu-categories';
import Banner from './banner';
import FlagNew from './flag-new';

let timeout = 0;
const Departments = ({ departmentsTree, allDepartments, isHovered, dispatchMetrics, ...props }) => {
  const [canMenuDepartmentMetrics, setCanMenuDepartmentMetrics] = useState(true);

  const onMouseEnterMenuDepartment = () => {
    if (canMenuDepartmentMetrics) {
      timeout = timerEventMetric(dispatchMetrics, 'menutemp', 'menu-header', 'menu-departamento', () =>
        setCanMenuDepartmentMetrics(false)
      );
    }
  };

  useEffect(
    () => () => {
      clearTimeout(timeout);
    },
    []
  );
  return (
    <Container isHovered={isHovered}>
      <Menu>
        {departmentsTree &&
          departmentsTree.map(department => (
            <Item
              key={department.id}
              onMouseEnter={() => onMouseEnterMenuDepartment()}
              onMouseLeave={() => clearTimeout(timeout)}
            >
              <Link
                to={department.link}
                onClick={() =>
                  dispatchMetrics('event:track', {
                    event: 'c:click',
                    action: 'click',
                    category: 'menu-header',
                    label: department.title,
                  })
                }
              >
                <ItemInner>
                  {department.title}
                  {department.flag === 'Novo' && <FlagNew />}
                </ItemInner>
                {department.children.length > 0 && <ArrowUI fill="#666" />}
              </Link>
              {department.children.length > 0 && (
                <Submenu>
                  <Categories categories={department.children} dispatchMetrics={dispatchMetrics} />
                  {isHovered && (
                    <Banner {...getImageBanner(props, department?.position)} radius="0" hasShadow={false} />
                  )}
                </Submenu>
              )}
            </Item>
          ))}

        <Item onMouseEnter={() => onMouseEnterMenuDepartment()} onMouseLeave={() => clearTimeout(timeout)}>
          <ButtonAllDepartments>
            todos os departamentos
            <ArrowUI fill="#666" />
          </ButtonAllDepartments>
          <Submenu>
            <AllDepartments departments={allDepartments} dispatchMetrics={dispatchMetrics} />
          </Submenu>
        </Item>
      </Menu>
    </Container>
  );
};

export default Departments;

const Container = styled.div`
  position: absolute;
  left: -12px;
  z-index: 9;
  min-width: 245px;
  transition: all 0.3s;
  top: ${({ isHovered }) => (isHovered ? 0 : '60px')};
  visibility: ${({ isHovered }) => (isHovered ? 'visible' : 'hidden')};
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
`;

const Menu = styled.ul`
  background-color: #fff;
  padding: 48px 0 0 0;
  margin: 0;
`;

const Item = styled.li`
  max-width: 245px;
  width: 100%;

  &:nth-last-child(2) {
    padding-bottom: 0.5rem;
  }

  ${({ theme }) =>
    css`
      &:hover {
        ${Link},
        ${ButtonAllDepartments} {
          background-color: ${theme.grey.lighter};
        }

        .submenu {
          left: 100%;
          opacity: 1;
          visibility: visible;
        }
      }
    `}
`;

const Link = styled(Nav)`
  display: block;
  font-size: 14px;
  padding: 8px 27px 8px 16px;
  transition: background-color 0.3s;
  background-color: #fff;
  position: relative;
  color: ${({ theme }) => theme.textColor};
  text-decoration: none;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.textColor};
    text-decoration: none;
  }
`;

const ItemInner = styled.span`
  position: relative;
`;

const ButtonAllDepartments = styled.strong`
  display: block;
  font-size: 14px;
  padding: 8px 27px 8px 16px;
  transition: background-color 0.3s;
  background-color: #fff;
  position: relative;
  cursor: default;
  padding: 10px 27px 10px 16px;
  border-top: ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textColor};
`;

const ArrowUI = styled(Arrow)`
  width: 10px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) rotate(-90deg);
`;
